import { ref } from 'vue';
import { defineStore } from 'pinia';
import { useMenusCustomizadosStore } from "@/stores/menusCustomizados";
import { useServicosStore } from "@/stores/servicos";

export const useMenuLateralStore = defineStore('menuLateral', () => {
    const isMenuLateralVisible = ref(false);

    // DESTAQUES
    const menusCustomizadosStore = useMenusCustomizadosStore();

    // SERVI�OS
    const servicosStore = useServicosStore();

    async function openMenu() {
        isMenuLateralVisible.value = true;

        getItensDestaque();

        getServicos();
    }

    function closeMenu() {
        isMenuLateralVisible.value = false;
    }

    function toggleMenu() {
        isMenuLateralVisible.value = !isMenuLateralVisible.value;
    }

    function getServicos() {
        servicosStore.getMenu(true);
    }

    function getItensDestaque() {
        menusCustomizadosStore.getMenusCustomizados();
    }

    return {
        isMenuLateralVisible,
        openMenu,
        closeMenu,
        toggleMenu
    }
});
